import { Grid, Navigation, Swiper } from "swiper";
import { addZero, isMobile, isTablet } from "@/modules/functions";

export class Clients {
  slider;
  total;
  current;
  clients;

  constructor() {}

  init() {
    this.clients = document.querySelector(".clients");
    if (!this.clients) return;

    Swiper.use([Navigation, Grid]);

    if (isMobile()) {
      this.initMobileSlider();
    } else {
      this.initDesktopSlider();
    }
  }

  initDesktopSlider() {
    const loopedSlides = document.querySelectorAll(
      ".clients-slider .swiper-slide"
    ).length;

    let loop = true;

    if (isTablet() && loopedSlides < 3) {
      loop = false;
      this.hideNavigation();
    }

    if (!isTablet() && loopedSlides < 5) {
      loop = false;
      this.hideNavigation();
    }

    this.slider = new Swiper(".clients-slider", {
      loop,
      spaceBetween: 50,
      loopedSlides,
      navigation: {
        prevEl: ".clients-slider-prev",
        nextEl: ".clients-slider-next",
      },
      breakpoints: {
        0: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
      },
    });

    this.slider.updateSize();

    window.addEventListener("resize", () => {
      this.slider.updateSize();
    });
  }

  hideNavigation() {
    this.clients.classList.add("clients-slider-hide-navigation");
  }

  initMobileSlider() {
    let loop = true;

    const looopedSlides = document.querySelectorAll(
      ".clients-slider .swiper-slide"
    ).length;

    this.nav = document.querySelector(".clients-slider-mobile-navigation")

    if (isMobile() && looopedSlides <= 6) {
      loop = false;
      this.nav.classList.add("clients-slider-mobile-navigation-hide");
    }

    this.current = document.querySelector(
      ".clients-slider-mobile-navigation-current"
    );
    this.total = document.querySelector(
      ".clients-slider-mobile-navigation-total"
    );

    this.total.innerText = addZero(
      Math.ceil(
        document.querySelectorAll(".clients-slider-mobile .swiper-slide")
          .length /
          3 -
          1
      )
    );
    this.current.innerText = addZero(1);

    this.slider = new Swiper(".clients-slider-mobile", {
      slidesPerView: 2,
      navigation: {
        prevEl: ".clients-slider-mobile-navigation-prev",
        nextEl: ".clients-slider-mobile-navigation-next",
      },
      grid: {
        rows: 3,
      },
      on: {
        slideChange: (swiper) => {
          this.current.innerText = addZero(swiper.activeIndex + 1);
        },
      },
    });
  }
}
